/* src/app/core/size-detector/size-detector.component.css */
/*# sourceMappingURL=size-detector.component.css.map */
